<template>
  <v-card v-if="loading">
    <v-skeleton-loader type="image" />
  </v-card>

  <v-card v-else flat class="card-bars d-flex justify-center">
    <v-card-text>
      <div v-if="isEmpty">
        <p>{{ $t('honda.dashboard.stats.no-data') }}</p>
      </div>

      <div v-else>
        <div class="card-bars-metric">
          <p class="metric-title">{{ title }}</p>
          <p class="metric-value">{{ current }}</p>
        </div>

        <div class="card-bars-graph">
          <v-chart ref="chart" :option="options" :autoresize="true" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import {computed, defineComponent, toRefs} from '@vue/composition-api'

export default defineComponent({
  name: 'CardBars',
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    current: {
      type: Number,
      required: false,
    },
    labels: {
      type: Array,
      required: false,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const {current, labels, data} = toRefs(props)

    const isEmpty = computed(() => {
      return !current?.value && current?.value !== 0
    })

    const options = computed(() => {
      return {
        color: ['#dc192d'],
        grid: {
          top: 10,
          left: 8,
          height: '100%',
          width: '75%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: labels?.value,
          axisLine: {show: false},
          axisTick: {show: false},
          axisLabel: {
            color: '#000',
            fontFamily: 'ProximaNovaRegular',
            fontSize: 14,
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 12,
            silent: true,
            label: {
              show: true,
              position: 'right',
              color: '#000',
              fontFamily: 'ProximaNovaRegular',
              fontSize: 14,
              valueAnimation: true,
            },
            data: data.value,
          },
        ],
      }
    })

    return {
      isEmpty,
      options,
    }
  },
})
</script>

<style>
.v-skeleton-loader__image {
  height: 270px;
}
</style>

<style lang="scss" scoped>
.card-bars {
  width: 100%;
  height: 270px;
  border-radius: 6px !important;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16) !important;
  overflow: hidden;
}

.metric-title {
  color: #222;
  font-family: 'ProximaNovaExCnSBold', system-ui, sans-serif;
  font-size: 20px;
  line-height: 1;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.metric-value {
  display: block;
  color: #222;
  font-family: 'ProximaNovaSemibold', system-ui, sans-serif;
  font-size: 32px;
  line-height: 1;
  margin-bottom: 5px;
}

.card-bars-graph {
  width: 100%;
  height: 150px;
}
</style>
